import { css, LitElement, html } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';

var css_248z = css`.text-small {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.py-2 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pr-3 {
  padding-right: 24px !important;
}

.pl-1 {
  padding-left: 8px !important;
}

.pr-1 {
  padding-right: 8px !important;
}

.smt-1 {
  margin-top: 4px !important;
}

.d-inline-block {
  display: inline-block !important;
}

.align-middle {
  vertical-align: middle !important;
}

.position-relative {
  position: relative !important;
}

.align-items-center {
  -ms-flex-align: center !important;
  align-items: center !important;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.toggle {
  width: 52px;
  height: 2rem;
  margin: 0px;
}

.toggle [type=checkbox] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle .toggle__slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #dedede;
  background-color: #fff;
  -webkit-transition: 0.15s;
  transition: 0.15s;
  border-radius: 1rem;
}

.toggle .toggle__slider:hover {
  background-color: #d8f0ef;
  border: 1px solid #86d1cd;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.toggle .toggle__slider::before {
  position: absolute;
  content: "";
  left: 3px;
  top: 3px;
  background-color: #fff;
  width: 24px;
  height: 24px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 1px 1px rgba(0, 0, 0, 0.16), 0px 3px 1px rgba(0, 0, 0, 0.1);
  transition: 0.15s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 -1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  -webkit-transition: 0.15s;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -moz-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.1), 0 -1px 1px 0 rgba(0, 0, 0, 0.16), 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  -moz-transition: 0.15s;
  -moz-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  border: 0.5px solid rgba(34, 34, 34, 0.04);
  border-radius: 50%;
}

.toggle input:checked + .toggle__slider {
  background-color: #00857a;
  border: 1px solid #00857a;
}

.toggle input:checked + .toggle__slider:hover {
  background-color: #00716b;
  border: 1px solid #00716b;
}

.toggle input:checked + .toggle__slider::before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

.aab-toggleswitch-label {
  max-width: 90%;
  color: #00716b;
}

.text-disabled {
  color: #999;
}

.aab-toggleswitch-sub-label {
  color: #808080;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.toggle input:disabled + .toggle__slider::before {
  background-color: #f9f9f9;
}

.toggle input:disabled + .toggle__slider {
  background-color: #f0f0f0;
  border: 1px solid #dedede;
}

.toggle input:checked:disabled + .toggle__slider {
  background-color: #ccc;
  border: 1px solid #ccc;
}`;

class AabToggleswitch extends ScopedElementsMixin(LitElement) {
  static get properties() {
    return {
      id: { type: String },
      label: { type: String },
      active: { type: Boolean },
      labelLocation: { type: String, attribute: 'label-location' },
      subLabel: { type: String, attribute: 'sub-label' },
      disabled: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.id = 'aab-toggleswitch-id';
    this.active = false;
    this.labelLocation = 'left';
  }

  static get styles() {
    return [css_248z];
  }

  static get scopedElements() {
    return {};
  }

  handleToggleSwitchClick() {
    if (!this.disabled) {
      this.active = !this.active;
      const AabToggleswitchClicked = new CustomEvent('aab-toggleswitch-clicked', {
        detail: {active: this.active, id: this.id},
        bubbles: true,
        composed: true,
      });
      this.dispatchEvent(AabToggleswitchClicked);
    }
  }

  handleKeyPress(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.handleToggleSwitchClick();
    }
  }

  renderSubLabel() {
    return html`
        <div class="smt-1">
           <span id="aab-toggleswitch-sub-label" class="text-small aab-toggleswitch-sub-label">${this.subLabel}</span>
         </div>
    `;
  }

  renderLabel() {
    return html`
     <div class="align-middle d-inline-block ${this.labelLocation === 'left' ? 'pr-1' : 'pl-1'}">
        <span id="aab-toggleswitch-label" class="aab-toggleswitch-label ${this.disabled ? 'text-disabled' : ''}">${this.label}</span>
        ${this.subLabel ? this.renderSubLabel() : ''}
     </div>`;
  }

  renderToggleButton() {
    return html`
      <span class="toggle d-inline-block align-middle position-relative">
          <input type="checkbox" id="${this.id}" .checked=${this.active} ?disabled=${this.disabled} @keypress="${(event) => this.handleKeyPress(event)}"
            @click="${() => this.handleToggleSwitchClick()}"/>
          <span class="toggle__slider"></span>
      </span>`;
  }

  renderToggleWithLeftLabel() {
    return html`
       <label id="aab-toggleswitch-label-left" class="d-inline-block align-items-center py-2 ${this.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}">
        ${this.label ? this.renderLabel() : ''}
        ${this.renderToggleButton()}
       </label>
    `;
  }

  renderToggleWithRightLabel() {
    return html`
      <label id="aab-toggleswitch-label-right" class="d-inline-block align-items-center py-2 ${this.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}">
        ${this.renderToggleButton()}
        ${this.label ? this.renderLabel() : ''}
      </label>
    `;
  }

  render() {
    const toggleWithLeftLabel = this.renderToggleWithLeftLabel();
    const toggleWithRightLabel = this.renderToggleWithRightLabel();

    return html`${this.labelLocation === 'left' ? html`${toggleWithLeftLabel}` : html`${toggleWithRightLabel}`}`;
  }
}

export { AabToggleswitch as default };
